import React, { useState } from "react";
import FormInput from "../../components/inputs/FormInput";
import Button from "../../components/button/Button";
import { TbPhoneCall } from "react-icons/tb";
import { HiOutlineMail } from "react-icons/hi";
import { IoLocationOutline } from "react-icons/io5";
import contactUsBg from '../../assets/images/backgrounds/contactUsBg.webp'
import { toast } from "react-toastify";

function ContactForm() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  
  const validateForm = () => {
    const { firstName, lastName, email, phone, message } = form;
  
    if (!firstName.trim()) {
      toast.error("Please enter your first name.");
      return false;
    }
  
    if (!lastName.trim()) {
      toast.error("Please enter your last name.");
      return false;
    }
  
    if (!email.trim()) {
      toast.error("Please enter your email.");
      return false;
    }
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }
  
    if (!phone.trim()) {
      toast.error("Please enter your phone number.");
      return false;
    }
  
    if (!/^\d{10}$/.test(phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return false;
    }
  
    if (!message.trim()) {
      toast.error("Please enter your message.");
      return false;
    }
  
    return true;
  };
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form Submitted:", form);
      toast.success("Message sent successfully!");
  
      // Optionally reset form
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    }
  };
  

  return (
    <div className="w-full max-w-4xl md:h-[450px] mx-auto bg-white md:rounded-xl shadow-md overflow-hidden mt-10 flex flex-col md:flex-row md:p-2">
      {/* Left Side - Contact Info */}
      <div className="w-full md:w-1/2 p-8 flex flex-col justify-center bg-no-repeat bg-cover bg-center rounded-tl-md rounded-bl-md"
       style={{
        backgroundImage: `url(${contactUsBg})`,
      }}
      >
        <h2 className="text-xl font-semibold text-defaultText mb-2">
          Contact Information
        </h2>
        <p className="text-defaultText mb-6 font-outfitRegular">
          Say something to start a live chat!
        </p>

        <div className="space-y-5 text-sm text-defaultText">
          <div className="flex items-center gap-3">
            <TbPhoneCall className="text-primary-900 text-3xl bg-white p-1 shadow-xl rounded-md" />
            <span>+91-91796 19315</span>
          </div>
          <div className="flex items-center gap-3">
            <HiOutlineMail className="text-primary-900 text-3xl bg-white p-1 shadow-xl rounded-md" />
            <span>info@eduprohub.in</span>
          </div>
          <div className="flex items-start gap-3">
            <IoLocationOutline className="text-primary-900 text-3xl bg-white p-1 shadow-xl rounded-md" />
            <span>
              11, Sampat Hills, Bicholi Mardana, Indore <br /> -452016 (M.P.)
            </span>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <form onSubmit={handleSubmit} className="w-full md:w-1/2 p-8 space-y-4">
        <div className="flex flex-col md:flex-row gap-4">
          <FormInput
            label="First Name"
            name="firstName"
            type="text"
            value={form.firstName}
            onChange={handleChange}
            className="flex-1"
          />
          <FormInput
            label="Last Name"
            name="lastName"
            type="text"
            value={form.lastName}
            onChange={handleChange}
            className="flex-1"
          />
        </div>

        <div className="flex flex-col md:flex-row gap-4">
          <FormInput
            label="Email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            className="flex-1"
          />
          <FormInput
            label="Phone Number"
            name="phone"
            type="phone"
            value={form.phone}
            onChange={handleChange}
            className="flex-1"
          />
        </div>

        <FormInput
          label="Message"
          name="message"
          type="textarea"
          value={form.message}
          onChange={handleChange}
        />

        <div className="text-right">
          <Button onClick={handleSubmit}>SEND MESSAGE</Button>
        </div>
      </form>
    </div>
  );
}

export default ContactForm;
